export default __webpack_public_path__ + "static/media/early-payment.8cdaf386.png";